import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { cdnUrl } from '../constants/generic';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface FooterProps {
  logoUrl: string;
}

const Footer: FC<FooterProps> = ({ logoUrl }) => {
  const location = useLocation();
  const showFooter =
    !location.pathname.includes('results') &&
    !location.pathname.includes('my-orders') &&
    !location.pathname.includes('proposal');

  useEffect(() => {
    const badge = document.getElementById('recaptcha-badge');
    if (!badge) return;

    badge.classList.toggle('is-hidden', !showFooter);
    badge.classList.toggle('footer-recaptcha--in-footer', showFooter);
  }, [showFooter]);

  if (!showFooter) {
    return null;
  }

  return (
    <div className="footer-wrapper">
      <div className="footer">
        <div className="col-md-3 col-6">
          <img
            className="footer-logo"
            src={
              logoUrl.startsWith('http') || logoUrl.includes('/static/media/')
                ? logoUrl
                : cdnUrl + logoUrl
            }
            alt="Logo"
          />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(Footer, 'Footer');
